import { Icon, toast } from '@livable/saas-react-components';
import { Alert, Box, Button, Container, Grid, Link, Typography } from '@mui/material';
import React from 'react';
import { BigSuccessAlert, BigInfoAlert, BigWarningAlert, BigErrorAlert, BigBrandAlert } from 'src/components/general/BigAlerts';
import useStyles from '../styles';
const alertBoxesExample = "\nimport { toast } from '@livable/saas-react-components';\n\ntoast('loading', store.account.resetAccountPasswordAsync.error.errorResp);\ntoast('success', store.account.resetAccountPasswordAsync.error.errorResp);\ntoast('info', store.account.resetAccountPasswordAsync.error.errorResp);\ntoast('warning', store.account.resetAccountPasswordAsync.error.errorResp);\ntoast('error', store.account.resetAccountPasswordAsync.error.errorResp);\n";
const simpleAlertExample = "\n<Alert severity=\"error\" icon={false} size=\"small\">\n  <Typography variant=\"h5\">Alert title</Typography>\n  <Typography variant=\"body1\">Alert text</Typography>\n</Alert>\n";
const simpleAlertWithCloseExample = "\n<Alert severity=\"error\" icon={false} size=\"small\" onClose={() => {}}>\n  <Typography variant=\"h5\">Alert title</Typography>\n  <Typography variant=\"body1\">Alert text</Typography>\n</Alert>\n";
const fullWidthAlertExample = "\nimport {\n  BigSuccessAlert,\n  BigInfoAlert,\n  BigWarningAlert,\n  BigErrorAlert,\n  BigBrandAlert,\n} from './components/BigAlerts';\n\n<BigErrorAlert>\n  <Typography variant=\"h4\">Text</Typography>\n  <Typography variant=\"body1\">Text</Typography>\n  <Link href=\"#\">Learn more</Link>\n</BigErrorAlert>\n";
const fullWidthAlertWithCloseExample = "\nimport {\n  BigSuccessAlert,\n  BigInfoAlert,\n  BigWarningAlert,\n  BigErrorAlert,\n  BigBrandAlert,\n} from './components/BigAlerts';\n\n<BigErrorAlert onClose={() => {}}>\n  <Typography variant=\"h4\">Text</Typography>\n  <Typography variant=\"body1\">Text</Typography>\n  <Link href=\"#\">Learn more</Link>\n</BigErrorAlert>\n";
export default function LvAlerts() {
  const classes = useStyles();
  const states = ['info', 'success', 'warning', 'error'];
  const toastText = {
    error: 'Error toast',
    info: 'Info toast',
    loading: 'Loading toast',
    success: 'Success toast',
    warning: 'Warning toast'
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    className: classes.section
  }, "Alerts"), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement("span", null, "Alert boxes "), /*#__PURE__*/React.createElement(Link, {
    href: "https://mui.com/material-ui/react-alert/#description",
    target: "_blank"
  }, "(documentation)")), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement("span", null, "Toasts "), /*#__PURE__*/React.createElement(Link, {
    href: "https://fkhadra.github.io/react-toastify/introduction",
    target: "_blank"
  }, "(documentation)")), Object.keys(toastText).map(type => /*#__PURE__*/React.createElement(Button, {
    key: type,
    onClick: () => toast(type, {
      body: [toastText[type]]
    }),
    variant: "contained",
    'custom-attribute': '485-alerts-page'
  }, toastText[type])), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, alertBoxesExample), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Simple"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, states.map(state => /*#__PURE__*/React.createElement("div", {
    className: classes.alertWrapper
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: state,
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Your data is protected"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "Automated: We use software, not people, to pull your data.", /*#__PURE__*/React.createElement("br", null), "Secure: We encrypt all credentials at rest and in transit.")))), /*#__PURE__*/React.createElement("div", {
    className: classes.alertWrapper
  }, /*#__PURE__*/React.createElement(Alert, {
    variant: "defaultGrey",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Your data is protected"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "Automated: We use software, not people, to pull your data.", /*#__PURE__*/React.createElement("br", null), "Secure: We encrypt all credentials at rest and in transit."))), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, simpleAlertExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, states.map(state => /*#__PURE__*/React.createElement("div", {
    className: classes.alertWrapper
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: state,
    icon: false,
    size: "small",
    onClose: () => {}
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Your data is protected"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "Automated: We use software, not people, to pull your data.", /*#__PURE__*/React.createElement("br", null), "Secure: We encrypt all credentials at rest and in transit.")))), /*#__PURE__*/React.createElement("div", {
    className: classes.alertWrapper
  }, /*#__PURE__*/React.createElement(Alert, {
    variant: "defaultGrey",
    icon: false,
    size: "small",
    onClose: () => {}
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Your data is protected"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "Automated: We use software, not people, to pull your data.", /*#__PURE__*/React.createElement("br", null), "Secure: We encrypt all credentials at rest and in transit."))), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, simpleAlertWithCloseExample))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Full width"), /*#__PURE__*/React.createElement("div", {
    className: classes.alertWrapper
  }, /*#__PURE__*/React.createElement(BigInfoAlert, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Cannot provide actual bill yet? You may estimate or skip the bill."), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "For estimated bill to be fair, the system requires several allocation prior. Skipped bill may be included in the next cycle, but only one consecutive month."), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '486-alerts-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Options")))), /*#__PURE__*/React.createElement("div", {
    className: classes.alertWrapper
  }, /*#__PURE__*/React.createElement(BigSuccessAlert, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Cannot provide actual bill yet? You may estimate or skip the bill."), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "For estimated bill to be fair, the system requires several allocation prior. Skipped bill may be included in the next cycle, but only one consecutive month."), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '487-alerts-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Options")))), /*#__PURE__*/React.createElement("div", {
    className: classes.alertWrapper
  }, /*#__PURE__*/React.createElement(BigWarningAlert, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Cannot provide actual bill yet? You may estimate or skip the bill."), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "For estimated bill to be fair, the system requires several allocation prior. Skipped bill may be included in the next cycle, but only one consecutive month."), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '488-alerts-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Options")))), /*#__PURE__*/React.createElement("div", {
    className: classes.alertWrapper
  }, /*#__PURE__*/React.createElement(BigErrorAlert, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Cannot provide actual bill yet? You may estimate or skip the bill."), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "For estimated bill to be fair, the system requires several allocation prior. Skipped bill may be included in the next cycle, but only one consecutive month."), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '489-alerts-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Options")))), /*#__PURE__*/React.createElement("div", {
    className: classes.alertWrapper
  }, /*#__PURE__*/React.createElement(BigBrandAlert, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Cannot provide actual bill yet? You may estimate or skip the bill."), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "For estimated bill to be fair, the system requires several allocation prior. Skipped bill may be included in the next cycle, but only one consecutive month."), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '490-alerts-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Options")))), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, fullWidthAlertExample), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Full width with close"), /*#__PURE__*/React.createElement("div", {
    className: classes.alertWrapper
  }, /*#__PURE__*/React.createElement(BigInfoAlert, {
    onClose: () => {}
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Cannot provide actual bill yet? You may estimate or skip the bill."), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "For estimated bill to be fair, the system requires several allocation prior. Skipped bill may be included in the next cycle, but only one consecutive month."), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '491-alerts-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Options")))), /*#__PURE__*/React.createElement("div", {
    className: classes.alertWrapper
  }, /*#__PURE__*/React.createElement(BigSuccessAlert, {
    onClose: () => {}
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Cannot provide actual bill yet? You may estimate or skip the bill."), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "For estimated bill to be fair, the system requires several allocation prior. Skipped bill may be included in the next cycle, but only one consecutive month."), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '492-alerts-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Options")))), /*#__PURE__*/React.createElement("div", {
    className: classes.alertWrapper
  }, /*#__PURE__*/React.createElement(BigWarningAlert, {
    onClose: () => {}
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Cannot provide actual bill yet? You may estimate or skip the bill."), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "For estimated bill to be fair, the system requires several allocation prior. Skipped bill may be included in the next cycle, but only one consecutive month."), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '493-alerts-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Options")))), /*#__PURE__*/React.createElement("div", {
    className: classes.alertWrapper
  }, /*#__PURE__*/React.createElement(BigErrorAlert, {
    onClose: () => {}
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Cannot provide actual bill yet? You may estimate or skip the bill."), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "For estimated bill to be fair, the system requires several allocation prior. Skipped bill may be included in the next cycle, but only one consecutive month."), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '494-alerts-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Options")))), /*#__PURE__*/React.createElement("div", {
    className: classes.alertWrapper
  }, /*#__PURE__*/React.createElement(BigBrandAlert, {
    onClose: () => {}
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Cannot provide actual bill yet? You may estimate or skip the bill."), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "For estimated bill to be fair, the system requires several allocation prior. Skipped bill may be included in the next cycle, but only one consecutive month."), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '495-alerts-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Options")))), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, fullWidthAlertWithCloseExample))));
}